type UserLogItem = {
  date: Date;
  log: string;
};

const start = new Date();
const userLog: UserLogItem[] = [];

export function addUserLog(log: string) {
  userLog.push({
    date: new Date(),
    log,
  });
}

export function userLogToString() {
  return userLog.map(l => '[' + toRelative(start, l.date) + '] ' + l.log).join('\n');
}

function toRelative(from: Date, to: Date) {
  const totalSeconds = Math.round((to.valueOf() - from.valueOf()) / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.floor(totalSeconds % 60);
  return zeroPad(minutes.toString()) + 'm ' + zeroPad(seconds.toString()) + 's';
}

function zeroPad(s: string) {
  return s.length === 1 ? '0' + s : s;
}
